$(function (ws) {
    'use strict';

    ws.views.accountLookup = ws.views.modal.extend({
        events: {
            'submit .searchForm': 'searchAccounts',
            'click .close-button': 'onClose',
            'click #submitAddAddress': 'submitNewAddressRequest',
            'click [data-event="close"]': 'onClose',
            'keyup .validate': 'validateField',
            'keyup #addressLine1': 'spaceEnteredOnFormFields',
            'keyup #accountName': 'spaceEnteredOnFormFields',
            'keyup #addressLine2': 'spaceEnteredOnFormFields',
            'keyup #addressLine3': 'spaceEnteredOnFormFields',
            'keyup #city': 'spaceEnteredOnFormFields',
            'keyup #zipCode': 'spaceEnteredOnFormFields',
            'focusout .validate': 'validateField',
            'click .address-mode': 'onClickMode',
            'change #industry': 'validateField',
            'change .enduser-state': 'validateField',
            'click .select-account': 'selectAccount',
            'change .countryChangeForMDM': 'onCountryChangeOfEnduserForm',
            'change .countryChangeForMDM-trillium': 'onTrilliumCountryChange',
            'focusout #accountName': 'tabOutOfFormFields',
            'focusout #addressLine1': 'tabOutOfFormFields',
            'focusout #addressLine2': 'tabOutOfFormFields',
            'focusout #addressLine3': 'tabOutOfFormFields',
            'focusout #city': 'tabOutOfFormFields',
            'focusout #zipCode': 'tabOutOfFormFields',
            'change #state': 'tabOutOfFormFields'
        },

        dynamicPopupDisplaySettings: function (enableDynamicPopup, addressList) {
            let parentClassName = this.type === 'SHIPTO' ? 'comp-ship-to-account-lookup' : 'comp-end-user-account-lookup';
            let triggerName = this.type === 'SHIPTO' ? 'destroyTableShipTo' : 'destroyTableEndCustomer';
            let addressSelector = this.type === 'SHIPTO' ? 'newAddress' : 'endUserNewAddress';
            $('.trilliumPopupError').hide();
            $('.serverResponseError').hide();
            $('.help-text').addClass('hide');
            $('.dynamic-info-text').hide();

            if (enableDynamicPopup && $('#enableMDMTrilliumAddressValidation').val() === 'true') {
                this.isTrilliumDynamicPopupOn = true;
                this.resetFormFields(this.$addFormFields);
                this.trilliumDefaults.addClass('hide');
                this.eventAgg.trigger(triggerName);

                $(`.${parentClassName} .nonTrilliumContents`).addClass('hide');
                $(`.${parentClassName} .noResults`).addClass('hide');
                $(`.${parentClassName} .serverResponseError`).addClass('hide').hide();
                $(`.${parentClassName} .addAddressForm .modalBtn`).addClass('hide');
                $(`.${parentClassName} .addAddressPopUp-header`).addClass('hide');
                $(`.${parentClassName} .dynamicPopUp-header`).removeClass('hide');
                $(`.${parentClassName} .dynamic-info-text`).show();

                this.$generalError.html($('.dynamicErrorMsg').val());
                this.$generalError.show();

                $(`.${parentClassName} .trillium-defaults-disable :input`).removeClass('fields-disabled').prop('disabled', false);
            } else {
                if (!$(`#${addressSelector}`).prop('checked')) {
                    let triggerName = $('.page-type').val() ? 'avoidTriggeringInternalSearchRfq' : 'avoidTriggeringInternalSearch';
                    this.eventAgg.trigger(triggerName);
                    $(`#${addressSelector}`).click();
                }

                this.isTrilliumDynamicPopupOn = false;

                this.resetFormFields(this.$addFormFields);
                this.trilliumDefaults.removeClass('hide');
                this.trilliumDefaultsButton.removeClass('hide');
                this.eventAgg.trigger(triggerName);
                $(`.${parentClassName} .addAddressPopUp-header`).removeClass('hide');
                $(`.${parentClassName} .dynamicPopUp-header`).addClass('hide');

                $(`.${parentClassName} .nonTrilliumContents`).removeClass('hide');
                $(`.${parentClassName} .noResults`).addClass('hide');
                $(`.${parentClassName} .serverResponseError`).addClass('hide').hide();
                $(`.${parentClassName} .addAddressForm .modalBtn`).removeClass('hide');
                $(`.${parentClassName} .dynamic-info-text`).hide();
                this.$generalError.hide();
                this.closedModalWithoutData = false;
                this.closeModal();

                this.fillFormOnSelectOfTrilliumAddress(addressList);
            }
        },

        fillFormOnSelectOfTrilliumAddress: function (addressList) {
            let parentClassName = this.type === 'SHIPTO' ? 'shipping-section' : 'endUser-section';
            this.trilliumResponseFromTrillium = addressList.trilliumResponse;
            let addressSelector = this.type === 'SHIPTO' ? 'newAddress' : 'endUserNewAddress';

            if (this.type === 'SHIPTO') {
                $('#selectedAddressId').val('');
            } else {
                $('#endUserSelectedAddressId').val('');
            }

            if ($(`#${addressSelector}`).prop('checked')) {
                $(`.${parentClassName}`).find('.createAddressLink').removeClass('hide');
            }

            $(`.${parentClassName} #country`).val(addressList.country ? addressList.country.isocode : '');
            $(`.${parentClassName} #country`).change();
            $(`.${parentClassName} #companyName`).val(addressList.accountName ? addressList.accountName : '');
            $(`.${parentClassName} #line1`).val(addressList.addressLine1 ? addressList.addressLine1 : '');
            $(`.${parentClassName} #line2`).val(addressList.addressLine2 ? addressList.addressLine2 : '');
            $(`.${parentClassName} #line3`).val(addressList.addressLine3 ? addressList.addressLine3 : '');
            $(`.${parentClassName} #line4`).val(addressList.addressLine4 ? addressList.addressLine4 : '');
            $(`.${parentClassName} #locality`).val(addressList.locality ? addressList.locality : '');
            $(`.${parentClassName} #city`).val(addressList.town ? addressList.town : '');
            $(`.${parentClassName} #zipCode`).val(addressList.zipCode ? addressList.zipCode : '');
            $(`.${parentClassName} #poBoxNumber`).val(addressList.poBox ? addressList.poBox : '');
            $(`.${parentClassName} #phone`).val(addressList.phone ? addressList.phone : '');
            $(`.${parentClassName} #countryCode`).val(addressList.countryCode ? addressList.countryCode : '').change();
            $(`.${parentClassName} #trilliumResponse`).val(addressList.trilliumResponse ? addressList.trilliumResponse : '');

            setTimeout(()=> {
                $(`.${parentClassName} #state`).val(addressList.state ? (addressList.country ? addressList.country.isocode : '') + '-' + addressList.state.toUpperCase() : '');
            }, 1000);

            this.submitTrilliumResponse = true;
        },

        disableAllFieldsOnInit: function () {
            let parentClassName = ['shipping-section', 'endUser-section'];

            parentClassName.forEach((className) => {
                $(`.${className} #country`).addClass('dropdown-disable');
                $(`.${className} #companyName`).prop('readonly', true);
                $(`.${className} #line1`).prop('readonly', true);
                $(`.${className} #line2`).prop('readonly', true);
                $(`.${className} #line3`).prop('readonly', true);
                $(`.${className} #line4`).prop('readonly', true);
                $(`.${className} #locality`).prop('readonly', true);
                $(`.${className} #city`).prop('readonly', true);
                $(`.${className} #zipCode`).prop('readonly', true);
                $(`.${className} #poBoxNumber`).prop('readonly', true);
                $(`.${className} #state`).addClass('dropdown-disable');
            });
        },

        spaceEnteredOnFormFields: function (e) {
            if (e.keyCode === 32) {
                this.validateFieldForMdmSearchCall(e);
            }
        },

        tabOutOfFormFields: function (e) {
            if (this.isTrilliumDynamicPopupOn) {
                let fieldName = e.currentTarget.name;
                let reqFieldLength = this.requiredDynamicFieldLengths;

                if (reqFieldLength[fieldName] !== undefined || fieldName === 'state') {
                    let forceExec = true;
                    if (reqFieldLength[fieldName] !== 0 && $(e.currentTarget).val().length === 0 && fieldName !== 'state') {
                        forceExec = false;
                    }

                    this.validateFieldForMdmSearchCall(e, true, forceExec);
                }
            } else {
                this.validateFieldForMdmSearchCall(e);
            }
        },

        validateFieldForMdmSearchCall: function (e, fromButton, forceExecution) {
            let validVlaues = false;
            let parentClassName = this.type === 'SHIPTO' ? 'comp-ship-to-account-lookup' : 'comp-end-user-account-lookup';
            let triggerName = '';
            let fieldName = e.currentTarget.name;
            let postalCodeValid = true;

            if (this.isTrilliumDynamicPopupOn) {
                triggerName =  this.type === 'SHIPTO' ? 'trilliumDynamicSearchShipTo' : 'trilliumDynamicSearchEndCustomer';
            } else {
                triggerName = this.type === 'SHIPTO' ? 'mdmDynamicSearchShipTo' : 'mdmDynamicSearchEndCustomer';
            }

            if ($(`.${parentClassName} #zipCode`).data('mandatory') && this.requiredDynamicFieldLengths.zipCode != 0) {
                if ($(`.${parentClassName} #zipCode`).val().trim().length) {
                    postalCodeValid = true;
                } else {
                    postalCodeValid = false;
                }
            } else {
                postalCodeValid = true;
            }

            if (this.isTrilliumDynamicPopupOn) {
                if ($('#enableMDMTrilliumAddressValidation').val() === 'true' && postalCodeValid && $(`.${parentClassName} #accountName`).val().length && $(`.${parentClassName} #addressLine1`).val().trim().length) {
                    if (($(e.currentTarget).val().trim().length >= this.requiredDynamicFieldLengths[fieldName] && this.requiredDynamicFieldLengths[fieldName] != 0) || forceExecution) {
                        validVlaues = true;
                    }
                }
            } else {
                validVlaues = true;
            }

            if (['mdmDynamicSearchShipTo', 'mdmDynamicSearchEndCustomer'].includes(triggerName) && !fromButton) {
                if (triggerName === 'mdmDynamicSearchShipTo') {
                    $('.comp-ship-to-account-lookup #submitAddAddress').val($('.addAddressLabel').val());
                } else {
                    $('.comp-end-user-account-lookup #submitAddAddress').val($('.addAddressLabel').val());
                }
            } else if (validVlaues) {
                clearTimeout(this.myVar);
                this.myVar = setTimeout(() => {
                    if (['mdmDynamicSearchShipTo', 'mdmDynamicSearchEndCustomer'].includes(triggerName)) {
                        this.eventAgg.trigger(triggerName, parentClassName, true);
                    } else {
                        this.eventAgg.trigger(triggerName, parentClassName);
                    }
                }, 1000);
            }
        },

        onTrilliumCountryChange: function (e) {
            if ($('#enableMDMTrilliumAddressValidation').val() === 'true') {
                if ($(e.currentTarget).val() === '') {
                    this.trilliumDefaults.addClass('hide');
                    this.trilliumDefaultsButton.addClass('hide');
                } else {
                    if (this.isTrilliumDynamicPopupOn) {
                        $('.trilliumDefaults-first').removeClass('hide');
                    } else {
                        this.trilliumDefaults.removeClass('hide');
                        this.trilliumDefaultsButton.removeClass('hide');
                    }
                }

                let triggerName = this.type === 'SHIPTO' ? 'destroyTableShipTo' : 'destroyTableEndCustomer';
                this.eventAgg.trigger(triggerName);
            }
        },

        onCountryChangeOfEnduserForm: function (e) {
            if (e && $(e.currentTarget).val() === ' ') {
                this.trilliumDefaults.addClass('hide');
                this.trilliumDefaultsButton.addClass('hide');
                return;
            } else if ($('#enableMDMTrilliumAddressValidation').val() === 'true') {
                if (this.countries) {
                    this.updateFieldsWithCountryOnEnduserForm(e);
                } else {
                    this.countries = new ws.models.shippingCountry({
                        quoteId: $('input[name="quoteCode"]').val()
                    });
                    this.countries.fetch({
                        success: this.updateFieldsWithCountryOnEnduserForm.bind(this, e)
                    });
                }
            }
        },

        /**
         * Update address fields with selected country
         */
        updateFieldsWithCountryOnEnduserForm: function(e) {
            let dynamicDisplayFieldNames = ['mdmAddressStateShow', 'mdmAddressPostalCodeShow', 'mdmAddressPOBoxShow'];
            let dynamicMandatoryFieldNames = ['regionRequired', 'mdmAddressPostalCodeMandatory', 'mdmAddressPOBoxMandatory'];
            let dynamicFieldsIds = ['state', 'zipCode', 'poBoxNumber'];
            let parentClassName = this.type === 'SHIPTO' ? 'comp-ship-to-account-lookup' : 'comp-end-user-account-lookup';
            let addressType = this.type === 'SHIPTO' ? 'selectFromAddress' : 'endUserSelectFromAddress';
            let country = this.countries.getCountry($(`.${parentClassName} .countryChangeForMDM`).val());
            let fieldLabels = {
                addStateLabel: {
                    optional: 'State/Province/Country (Optional):',
                    mandatory: 'State/Province/Country:'
                },
                addZipLabel: {
                    optional: 'ZIP/Postal Code (Optional):',
                    mandatory: 'ZIP/Postal Code:'
                },
                poBoxNumber: {
                    optional: 'PO Box Number (Optional):',
                    mandatory: 'PO Box Number:'
                }
            };

            if (country && $('#enableMDMTrilliumAddressValidation').val() != 'true') {
                if (country.postalCodeRequired) {
                    $(`.${parentClassName} #zipCode`).data('mandatory', 'true');
                } else {
                    $(`.${parentClassName} #zipCode`).data('mandatory', 'false');
                }

                if (country.regionRequired) {
                    $(`.${parentClassName} .enduser-state`).data('mandatory', 'true');
                } else {
                    $(`.${parentClassName} .enduser-state`).data('mandatory', 'false');
                }
            }

            if (country && $('#enableMDMTrilliumAddressValidation').val() === 'true') {
                if (e && !(e.isTrigger) || this.isTrilliumDynamicPopupOn) {
                    $(`.${parentClassName} .trilliumDefaults-first :input`).val('');
                }

                dynamicDisplayFieldNames.forEach((field, index) => {
                    if (country[field]) {
                        $(`.${parentClassName} #${dynamicFieldsIds[dynamicDisplayFieldNames.indexOf(field)]}`).closest('.padding-top').removeClass('hide');
                        $(`.${parentClassName} #${dynamicFieldsIds[index]}`).data('mandatory', country[dynamicMandatoryFieldNames[index]]);

                        if (country[dynamicMandatoryFieldNames[index]]) {
                            $(`.${parentClassName} label[for='${Object.keys(fieldLabels)[index]}']`).text(fieldLabels[Object.keys(fieldLabels)[index]].mandatory);
                        } else {
                            $(`.${parentClassName} label[for='${Object.keys(fieldLabels)[index]}']`).text(fieldLabels[Object.keys(fieldLabels)[index]].optional);
                        }
                    } else {
                        $(`.${parentClassName} #${dynamicFieldsIds[dynamicDisplayFieldNames.indexOf(field)]}`).closest('.padding-top').addClass('hide');
                        $(`.${parentClassName} #${dynamicFieldsIds[index]}`).data('mandatory', false);
                    }
                });
            }

            let countrycode = $(`.${parentClassName} .countryChangeForMDM`).val();
            var regions = new ws.collections.shippingStates([], {
                iso: countrycode
            });

            regions.fetch().done(function (regions) {
                this.updateStatesWithData(regions, parentClassName, countrycode);
            }.bind(this));
        },

        updateStatesWithData: function (regions, parentClassName, countrycode) {
            let options = '<option value=""></option>';
            $(`.${parentClassName} .enduser-state`).empty();

            _.each(regions, (region) => {
                options += `<option value="${countrycode}-${region.isocodeShort}">${region.name}</option>`;
            });

            $(`.${parentClassName} .enduser-state`).append(options);
        },

        /**
         * Initialize the component.
         */
        initialize: function () {
            ws.views.modal.prototype.initialize.call(this);

            this.type = this.$('input.parameters').data('type');
            this.selectEvent = this.$('input.parameters').data('select-event');
            this.selectButtonText = this.$('input.parameters').data('select-button-text');

            this.$generalError = this.$('.generalError');

            this.quoteNumber = $('#quoteCode').val();
            this.updateUrl = globals.path.api.quoting.updateAccounts.replace('${quoteNumber}', this.quoteNumber);

            this.$dataTable = this.$('.comp-data-table');
            this.$dataTableBody = this.$dataTable.find('tbody');
            this.$results = this.$('.results');
            this.$noResults = this.$('.no-results');
            this.$dataTableObject = null; // Store this reference to be able to destroy it

            this.$searchModeRadio = this.$('input[type="radio"][value="search"]');
            this.$searchForm = this.$('form.searchForm');
            this.$searchFormInvalidAlert = this.$searchForm.find('.alert');
            this.$searchFormFields = this.$searchForm.find('input[type=text]');
            this.$addForm = this.$('form.addAddressForm');
            this.$addFormFields = this.$addForm.find('input[type=text], input[type=radio], select');
            this.trilliumDefaults = this.$('.trilliumDefaults');
            this.trilliumDefaultsButton = this.$('.addAddressForm .modalBtn');

            this.collection = new ws.collections.accountLookup();
            this.collection.on('change', this.renderSearchedAccounts);

            this.on('onClose', this.displayResults.bind(this, false, false));
            this.on('onClose', this.destroyDataTable.bind(this));
            this.eventAgg.on('selectTrilliumSuggestedAccount' + this.type, this.selectAccount, this);
            this.eventAgg.on('dynamicPopupDisplaySettings' + this.type, this.dynamicPopupDisplaySettings.bind(this));
            this.eventAgg.on('selectingFromLink', this.selectingFromLink, this);

            this.$addAddressForm = this.$('form.addAddressForm');

            this.trilliumAddressCheck = new ws.models.trilliumAddressCheck({
                quoteNumber: this.quoteNumber
            });

            this.searchAccountButton = $('.searchForm .button.yes');
            this.closedModalWithoutData = true;

            setTimeout(() => {
                this.onCountryChangeOfEnduserForm();

                this.requiredDynamicFieldLengths = {
                    addressLine1: Number($('#dynamicAddressLine1Length').val()),
                    addressLine2: Number($('#dynamicAddressLine2Length').val()),
                    addressLine3: Number($('#dynamicAddressLine3Length').val()),
                    zipCode: Number($('#dynamicZipCodeLength').val()),
                    city: Number($('#dynamicCityLength').val())
                };

                if ($('#enableMDMTrilliumAddressValidation').val() === 'true') {
                    this.disableAllFieldsOnInit();
                    $('.addAddressForm .row').css('margin-bottom', '30px');
                    $('.addAddressForm .modalBtn').css({position: 'absolute', bottom: '0', left: '50%', 'margin-left': '-157px'});
                }
            }, 2000);

            this.myVar = function () {};
        },

        selectingFromLink: function () {
            this.closedModalWithoutData = false;
        },

        resetAddAddressPopup: function () {
            let parentClassName = this.type === 'SHIPTO' ? 'comp-ship-to-account-lookup' : 'comp-end-user-account-lookup';
            let childClassId = this.type === 'SHIPTO' ? 'selectFromAddress' : 'endUserSelectFromAddress';
            let sectionType = this.type === 'SHIPTO' ? 'shipping-section' : 'endUser-section';

            $(`.${parentClassName} #country`).val('');
            $(`.${parentClassName} #accountName`).val('');
            $(`.${parentClassName} #addressLine1`).val('');
            $(`.${parentClassName} #addressLine2`).val('');
            $(`.${parentClassName} #addressLine3`).val('');
            $(`.${parentClassName} #addressLine4`).val('');
            $(`.${parentClassName} #addressLine5`).val('');
            $(`.${parentClassName} #city`).val('');
            $(`.${parentClassName} #zipCode`).val('');
            $(`.${parentClassName} #state`).val('');

            if (this.closedModalWithoutData) {
                $(`.${sectionType} #${childClassId}`).click();
                $(`.${sectionType} .newAddress-fieldset`).prop('disabled', true);
            }

            this.closedModalWithoutData = true;
        },

        /**
         * Changes modes between search and create.
         *
         * @param {Event} e
         */
        onClickMode(e) {
            this.switchMode(e.target.value);
        },

        /**
         * Changes modes between search and create.
         *
         * @param {string} mode
         */
        switchMode(mode) {
            $('.trilliumPopupError').hide();
            this.$addAddressForm.removeClass('hide-form');
            this.$searchForm.addClass('hide-form');
            this.resetFormFields(this.$searchFormFields);
            this.displayResults(false, false, true);
            this.$searchFormInvalidAlert.hide();
            this.$searchForm.removeClass('search-error');
            this.resetFormFields(this.$addFormFields);
            this.$generalError.html('');
            this.$generalError.hide();

            if ($('#enableMDMTrilliumAddressValidation').val() === 'true') {
                //For reseting dynamic trillium settings
                let parentClassName = this.type === 'SHIPTO' ? 'comp-ship-to-account-lookup' : 'comp-end-user-account-lookup';
                $(`.${parentClassName} .nonTrilliumContents`).removeClass('hide');
                $(`.${parentClassName} .noResults`).addClass('hide');
                $(`.${parentClassName} .addAddressForm .modalBtn`).removeClass('hide');
                $(`.${parentClassName} .trillium-defaults-disable :input`).removeClass('fields-disabled').prop('disabled', false);

                this.isTrilliumDynamicPopupOn = false;
                this.submitTrilliumResponse = false;
                this.trilliumDefaults.addClass('hide');
                this.trilliumDefaultsButton.addClass('hide');
                let triggerName = this.type === 'SHIPTO' ? 'destroyTableShipTo' : 'destroyTableEndCustomer';
                this.eventAgg.trigger(triggerName);
            } else {
                this.trilliumDefaults.removeClass('hide');
                this.trilliumDefaultsButton.removeClass('hide');
            }
        },

        /**
         * Validates the field.
         *
         * @param {Event} e
         */
        validateField: function (e) {
            if ($(e.currentTarget).val() !== '' && e.type === 'focusout') {
                $(e.currentTarget).removeClass('error');
                var pElement = $(e.currentTarget).parent().find('.field-level-error');
                pElement.addClass('hide');
            }

            // On changing the dropdown, remove the existing error message
            if ($(e.currentTarget).attr('name') == 'industry') {
                $(e.currentTarget).parent().next().addClass('hide');
            }

            if ($(e.currentTarget).attr('name') == 'state' && $('#addressValidationMDM').val() === 'true') {
                $(e.currentTarget).parent().next().addClass('hide');
            }
        },

        /**
         * Validates the element prior to submitting the form;
         * returns false if invalid, true if valid.
         *
         * @param {jQuery} $element
         * @returns {boolean}
         */
        validateBeforeSubmit: function ($element) {
            var mandatory = $element.data('mandatory');

            // Check if the element is mandatory, but no value exists
            // else check for the select dropdown with id industry, but no value exists
            if ((mandatory === 'true' || mandatory === true) && $element.val() === '' && $element.attr('id') != 'state') {
                var pElement = $element.parent().find('.field-level-error');
                pElement.removeClass('hide');
                $element.addClass('error');
                return false;
            } else if ((mandatory === 'true' || mandatory === true) && $element.attr('id') == 'state' && ($element.val() === null || $element.val() === '')) {
                $element.addClass('error');
                $element.parent().next().removeClass('hide');
                return false;
            } else if ($element.attr('id') == 'industry' && $element.val() === '') {
                $element.parent().next().removeClass('hide');
                return false;
            } else if ($element.attr('id') == 'addContactEmail' && $element.val() !== '') {
                let isEmailValid = globals.validateEmail($element.val());
                if (isEmailValid === false) {
                    $element.addClass('error');
                    $element.parent().find('.field-level-error').removeClass('hide');
                    return false;
                }
            } else if (($element.attr('id') == 'phone' || $element.attr('id') == 'addContactPhoneNum') && $element.val() !== '') {
                let regex = /^[0-9 ()]*$/;
                let isPhoneValid = regex.test($element.val());
                if (isPhoneValid === false) {
                    $element.addClass('error');
                    $element.parent().find('.field-level-phone-error').removeClass('hide');
                    return false;
                }
            }

            // Everything validated; return true
            return true;
        },

        /**
         * This will submit POST request to Add new address
         */
        submitNewAddressRequest: function (e) {
            e.preventDefault();
            var _this = this;
            var errors = 0;
            var data = {};
            this.$addAddressForm.find('input[type="text"]').each(function() {
                var $this = $(this);
                data[$this.attr('name')] = $this.val().trim();
                errors += _this.validateBeforeSubmit($this) ? 0 : 1;
            });

            this.$addAddressForm.find('input[type="radio"]').each(function() {
                var $this = $(this);
                data[$this.attr('name')] = $this.val();
            });

            this.$addAddressForm.find('input[type="hidden"]').each(function() {
                var $this = $(this);
                data[$this.attr('name')] = $this.val();
            });

            this.$addAddressForm.find('select').each(function() {
                var $this = $(this);
                data[$this.attr('name')] = $this.val();
                errors += _this.validateBeforeSubmit($this) ? 0 : 1;
            });

            var triggerName = 'accountAddAddress(' + this.type + '):open';

            if ($('#enableMDMTrilliumAddressValidation').val() === 'true') {
                let poNum = data.poBoxNumber.split('').filter((num) => {
                    if (num != '9') {
                        return true;
                    }
                }).join('');

                if (poNum.length == 0 || data.poBoxNumber == 0) {
                    data.poBoxNumber = '';
                }
            }

            if (errors === 0) {
                if ($(e.currentTarget).val() === $('.addAddressLabel').val()) {
                    this.validateFieldForMdmSearchCall(e, true);
                    $(e.currentTarget).val($('.validateAddressLabel').val());
                } else {
                    let userData = data;
                    this.$addAddressForm.find('input[type="submit"]').attr('disabled', true);
                    globals.disableApp();

                    if (this.submitTrilliumResponse) {
                        let countrySelected = data.country;
                        data.country = {};
                        data.trilliumResponse = this.trilliumResponseFromTrillium ? this.trilliumResponseFromTrillium : true;
                        data.town = data.city;
                        data.country.isocode = countrySelected;
                        data.contact = {
                            firstName: userData.contactFirstName,
                            lastName: userData.contactLastName,
                            phone: userData.contactPhoneNumber,
                            email: userData.contactEmail
                        };

                        this.eventAgg.trigger('submitUserSelection', undefined, data);
                        this.$addAddressForm.find('input[type="submit"]').removeAttr('disabled');
                        this.closeModal();
                        globals.enableApp();

                        return;
                    }

                    if ($('#enableMDMTrilliumAddressValidation').val() === 'true') {
                        let url = $('.page-type').val() ? globals.path.api.westcon.trilliumAddressCheckRFQ : globals.path.api.westcon.trilliumAddressCheck;
                        $.get(url, data, (data) => {
                            this.$addAddressForm.find('input[type="submit"]').removeAttr('disabled');
                            globals.enableApp();
                            if (data.error && data.enableDynamicTrilliumSearch) {
                                this.dynamicPopupDisplaySettings(true);
                                this.resetAddAddressPopup();
                            } else if (data.error) {
                                var html = '<ul>';
                                _.each(data.errors, function (error) {
                                    html += '<li>' + error.message + '</li>';
                                });
                                html += '</ul>';
                                this.$generalError.html(html);
                                this.$generalError.show();
                            } else {
                                this.$generalError.html('');
                                this.$generalError.hide();

                                if (data.suggested && data.suggested.length) {
                                    data.reformatted = data.suggested[0];
                                    data.reformatted.type = this.type;
                                    data.suggested = null;

                                    this.setAddressToForm(data.reformatted);
                                } else {
                                    this.eventAgg.trigger('submitUserSelection', undefined, userData);
                                }

                                this.closeModal();
                                $('.address-id').removeClass('highlightCell');
                            }
                        });
                    }
                }
            }
        },

        /**
         * Searches for accounts.
         * @param {Event} e
         */
        searchAccounts: function(e) {
            e.preventDefault();

            // Make sure we have a valid form
            if (!this._searchFormIsValid()) {
                // Hide all results
                this.displayResults(false, false, true);
                this.$searchFormInvalidAlert.show();
                this.$searchForm.addClass('search-error');
                return;
            }
            else {
                this.$searchFormInvalidAlert.hide();
                this.$searchForm.removeClass('search-error');
            }

            this.enableSearchButton(false);
            this.renderSearchedAccounts();
        },

        /**
         * Enabling and disabling of spinners and button
         *
         * @param {boolean} isEnabled
         */
        enableSearchButton: function (isEnabled = true) {
            if (isEnabled) {
                this.searchAccountButton.removeClass('spinner-after');
                this.searchAccountButton.prop('disabled', false);
            } else {
                this.searchAccountButton.addClass('spinner-after');
                this.searchAccountButton.prop('disabled', true);
            }
        },

        /**
         * Determines whether or not the form is valid.
         * Assumes all search form fields are text inputs.
         *
         * @return {boolean}
         * @protected
         */
        _searchFormIsValid: function() {
            var isValid = false;
            this.$searchFormFields.each(function() {
                isValid = isValid || $(this).val().trim() !== '';
            });

            return isValid;
        },

        /**
         *  Render the searched accounts.
         */
        renderSearchedAccounts: function () {
            let url = globals.path.api.quoting.searchAccounts.replace('{quoteNumber}', this.quoteNumber) + '?' + this.$searchForm.serialize();
            url = url.replace('${quoteNumber}', this.quoteNumber);

            // Generate the DataTable
            let dataTableOptions = {
                bFilter: false,
                bLengthChange: false,
                ordering: false,
                processing: false,
                serverSide: true,
                destroy: !!this.$dataTableObject,
                ajax: {
                    url: url,
                    dataSrc: this.parseDataForTable.bind(this),
                    data: (d) => {
                        d.page = Math.floor(d.start / d.length);
                    }
                }
            };

            this.$dataTableObject = this.$dataTable.find('table')
                .on('xhr.dt', this.onDataTableAjax.bind(this))
                .DataTable(dataTableOptions);
        },

        /**
         * Selects the account.
         *
         * @param {Event} e
         */
        selectAccount: function(e) {
            let address = JSON.parse(e.target.dataset.address);
            let type = e.target.dataset.type;
            this.closedModalWithoutData = false;

            if ($('#enableMDMTrilliumAddressValidation').val() === 'true' && (address.trilliumResponse === null || address.trilliumResponse === '' || address.trilliumResponse === ' ')) {
                let url = globals.path.api.westcon.checkTrilliumAddress + '?selectedAccountId=' + address.sapId + '&type=' + type;
                $('.trilliumPopupError').hide();

                globals.disableApp();
                $.get(url, (res) => {
                    globals.enableApp();
                    if (res) {
                        address.trilliumResponse = res;
                        this.setAddressToForm(address);
                        this.closeModal();
                    } else {
                        $('.trilliumPopupError').show();
                        this.closedModalWithoutData = true;
                    }
                });
            } else if (address.trilliumResponse && $('#enableMDMTrilliumAddressValidation').val() === 'true') {
                $('.trilliumPopupError').hide();
                this.setAddressToForm(address);
                this.closeModal();
            } else {
                $('.trilliumPopupError').hide();
                this.setAddressToForm(address);
                this.closeModal();
            }
        },

        setAddressToForm: function (addressList) {
            let parentClassName = this.type === 'SHIPTO' ? 'shipping-section' : 'endUser-section';
            this.trilliumResponseFromTrillium = addressList.trilliumResponse;
            let addressSelector = this.type === 'SHIPTO' ? 'newAddress' : 'endUserNewAddress';

            if (this.type === 'SHIPTO') {
                $('#selectedAddressId').val(addressList.sapId ? addressList.sapId : '');
            } else {
                $('#endUserSelectedAddressId').val(addressList.sapId ? addressList.sapId : '');
            }

            if ($(`#${addressSelector}`).prop('checked')) {
                $(`.${parentClassName}`).find('.createAddressLink').removeClass('hide');
            }

            $(`.${parentClassName} #country`).val(addressList.country ? addressList.country.isocode : '');
            $(`.${parentClassName} #country`).change();
            $(`.${parentClassName} #companyName`).val(addressList.accountName ? addressList.accountName : '');
            $(`.${parentClassName} #line1`).val(addressList.addressLine1 ? addressList.addressLine1 : '');
            $(`.${parentClassName} #line2`).val(addressList.addressLine2 ? addressList.addressLine2 : '');
            $(`.${parentClassName} #line3`).val(addressList.addressLine3 ? addressList.addressLine3 : '');
            $(`.${parentClassName} #line4`).val(addressList.addressLine4 ? addressList.addressLine4 : '');
            $(`.${parentClassName} #locality`).val(addressList.locality ? addressList.locality : '');
            $(`.${parentClassName} #city`).val(addressList.town ? addressList.town : '');
            $(`.${parentClassName} #zipCode`).val(addressList.zipCode ? addressList.zipCode : '');
            $(`.${parentClassName} #poBoxNumber`).val(addressList.poBox ? addressList.poBox : '');
            $(`.${parentClassName} #phone`).val(addressList.phone ? addressList.phone : '');
            $(`.${parentClassName} #countryCode`).val(addressList.countryCode ? addressList.countryCode : '').change();
            $(`.${parentClassName} #trilliumResponse`).val(addressList.trilliumResponse ? addressList.trilliumResponse : '');

            setTimeout(()=> {
                $(`.${parentClassName} #state`).val(addressList.state ? (addressList.country ? addressList.country.isocode : '') + '-' + addressList.state.toUpperCase() : '');
            }, 1000);
        },

        /**
         * Shows or hides the results & no results sections.
         *
         * @param {boolean} showResults
         * @param {boolean} showNoResults
         */
        displayResults: function(showResults, showNoResults, onOpen) {
            this.$results.toggle(showResults);
            this.$noResults.toggle(showNoResults);

            // If everything is being reset, reset the form too
            if (!showResults && !showNoResults) {
                this.$searchForm.removeClass('search-error');
                this.$searchFormInvalidAlert.hide();
                this.resetFormFields(this.$searchFormFields);
                this.resetFormFields(this.$addFormFields);
            }

            $(window).trigger('resize');
            this.enableSearchButton();

            $(`.addAddressPopUp-header`).removeClass('hide');
            $(`.dynamicPopUp-header`).addClass('hide');
            $('.help-text').addClass('hide');
            $('.dynamic-info-text').hide();
            $('.serverResponseError').hide();
            if (!onOpen) {
                this.resetAddAddressPopup();
            }
        },

        /**
         * Resets all form fields.
         * NOTE: Business request to make fax with default value "000"
         * @param {jQuery} $formFields
         */
        resetFormFields($formFields) {
            const radioNames = [];
            var _this = this;
            $formFields.each(function() {
                const $this = $(this);

                // Select the first option in the dropdown
                if ($this[0].tagName === 'SELECT') {
                    $this[0].selectedIndex = 0;

                    // Added change for DTSP-3512 : 1VOE: Default Industry to COMM
                    if (($this.attr('name') === 'country' || $this.attr('name') === 'language' || $this.attr('name') === 'industry') && $this.attr('default')) {
                        $this.val($this.attr('default'));
                    }

                    var $selectElementErrorMessage = $this.parent().next();
                    if (!$selectElementErrorMessage.hasClass('hide')) {
                        $selectElementErrorMessage.addClass('hide');
                    }
                }
                else {
                    switch ($this.attr('type')) {
                        // Clear out the text input
                        case 'text':
                            if (_this.type === 'ENDCUSTOMER' && !_.isEmpty($this.data('value'))) {
                                $this.val($this.data('value'));
                            } else {
                                if (_this.type === 'SHIPTO' && !_.isEmpty($this.data('value'))) {
                                    $this.val($this.data('value'));
                                } else {
                                    if ($this.attr('name') === 'fax') {
                                        $this.val('000');
                                    } else {
                                        $this.val('');
                                    }
                                }
                            }

                            var $textElementErrorMessage = $this.parent().find('.field-level-error');
                            if (!$textElementErrorMessage.hasClass('hide')) {
                                $textElementErrorMessage.addClass('hide');
                            }

                            break;

                        // Check the radio button iff something else isn't checked
                        case 'radio':
                            const radioName = $this.attr('name');
                            if (!_.includes(radioNames, radioName)) {
                                radioNames.push(radioName);
                                $this.prop('checked', true);
                            }
                    }
                }
            });
        },

        /**
         * Sets the mode to be search on open.
         *
         * @param {Event} ev
         */
        onOpen(ev) {
            // Set the mode to search if it exists
            if (this.$searchModeRadio) {
                this.$searchModeRadio.prop('checked', true);
            }

            // Change mode to search
            this.switchMode('search');

            // Reset the form
            this.displayResults(false, false, true);
            setTimeout(function() {
                $('.countryChangeForMDM').html($('.comp-shipping #country').html());
                $('.countryChangeForMDM').val('');
            }, 200);

            ws.views.modal.prototype.onOpen.call(this, ev);
        },

        /**
         * Prepares the data for consumption by DataTables
         * after it is received from the server.
         * Modifications are made directly to the json object,
         * which are then used in other DataTables functions.
         *
         * @param {Event} e
         * @param {Object} settings
         * @param {Object} json - The JSON to get back from the server
         */
        onDataTableAjax(e, settings, json) {
            const hasResults = (json.results.length > 0);
            this.displayResults(hasResults, !hasResults, true);
            this.enableSearchButton();
        },

        /**
         * Parses Datatable rows to display custom things
         *
         * @returns {Object} json - Object to be parsed by Datatables to display the data
         */
        parseDataForTable(json) {
            const selectButtonText = this.selectButtonText;
            const selectEvent = this.selectEvent;
            json.recordsTotal = json.pagination.totalNumberOfResults;
            json.recordsFiltered = json.pagination.totalNumberOfResults;
            json.data = json.results.map(obj => {
                //This is the same as accountModel.toOneLine but we couldn't use it because
                //of a mismatch between Datatables with Ajax & Backbone Collections
                const address = _.filter([
                        obj.addressLine1,
                        obj.addressLine2,
                        obj.addressLine3,
                        obj.addressLine4,
                        obj.locality,
                        obj.town,
                        obj.state,
                        obj.zipCode
                    ]).join(', ') + ' ' + obj.country.isocode;

                return [
                    obj.sapId,
                    obj.accountName,
                    _.template('<span><@= address @></span>')({
                        address: address
                    }),
                    _.template('<button class="select-account" data-address=\'<@= accountJSON @>\'><@= selectButtonText @></button>')({
                        accountJSON: JSON.stringify(obj).replace("'", '&#039;'),
                        selectButtonText: selectButtonText
                    })
                ];
            });

            return json.data;
        },

        /**
         * Destroy DataTable object to be reinitialised when opened again
         */
        destroyDataTable() {
            if (this.$dataTableObject) {
                this.$dataTableObject.destroy();
            }
        }
    });
}(westcon));
